export default __webpack_public_path__ + "static/media/Gauntlets of the Fallen Empire (nm).d33fd1fb.jpg";